// extracted by mini-css-extract-plugin
module.exports = {"roboimage_result":"RoboImageResult_roboimage_result__1ggDk","mobile_br":"RoboImageResult_mobile_br__1sDIt"};